import Box from '@mui/material/Box';
import { Delete } from '@sweep-io/sweep-design/dist/icons';
import { IconButton, Typography } from '@sweep-io/sweep-design';
import isEmpty from 'lodash/isEmpty';
import { AssignToComponent } from '../../pages/funnel-map-flow/dialogs/stage/AssignToComponent';
import { AssignmentsAssignTo } from '../../../types/AssignmentsAssignTo';
import { AssignmentOwnershipSelector } from '../../Automations/AssignmentOwnershipSelector';
import { AssignmentToType } from '../../../types/enums/AssignmentToType';
import { getMembershipFieldIdFromAssignTo } from './getMembershipFieldIdFromAssignTo';

import { useCallback } from 'react';

export const AssignToSection = ({
  crmOrgId,
  objectType,
  showFallback,
  assignedTo,
  assignedToFallback,
  allUsedOwnershipFieldIds,
  onChange,
  isAllowedBtn,
}: {
  crmOrgId: string;
  objectType: string;
  assignedTo?: Partial<AssignmentsAssignTo>;
  assignedToFallback?: Partial<AssignmentsAssignTo>;
  onChange: (_props: {
    assignedTo?: Partial<AssignmentsAssignTo>;
    assignedToFallback?: Partial<AssignmentsAssignTo>;
  }) => void;
  readonly?: boolean;
  showFallback?: boolean;
  allUsedOwnershipFieldIds: string[];
  isAllowedBtn?: boolean;
}) => {
  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <AssignToComponent
        crmOrgId={crmOrgId}
        readonly={!isAllowedBtn}
        assignTo={assignedTo}
        onChange={useCallback(
          (assignedTo) => {
            onChange({
              assignedTo,
              assignedToFallback: undefined,
            });
          },
          [onChange],
        )}
        objectType={objectType}
      />
      <Box>
        <AssignmentOwnershipSelector
          crmOrgId={crmOrgId}
          readonly={!isAllowedBtn}
          assignTo={assignedTo}
          onChange={useCallback(
            (assignTo) => {
              onChange({
                assignedTo: assignTo,
                assignedToFallback: assignedToFallback
                  ? {
                      ...assignedToFallback,
                      fieldMapping: assignTo.fieldMapping,
                    }
                  : undefined,
              });
            },
            [onChange, assignedToFallback],
          )}
          objectType={objectType}
          excludeFieldIds={allUsedOwnershipFieldIds.filter(
            (fieldId) => fieldId !== getMembershipFieldIdFromAssignTo(assignedTo),
          )}
          autoSelectDefault
        />
      </Box>
      {assignedTo?.type !== AssignmentToType.Queue && showFallback && (
        <Box display="flex" gap="12px" alignItems="center">
          <Typography variant="body">
            {`If  ${assignedTo?.type === AssignmentToType.Team ? 'all members reached their limit' : 'user is not available'}, assign to:`}
          </Typography>
          <AssignToComponent
            crmOrgId={crmOrgId}
            readonly={!isAllowedBtn}
            assignTo={assignedToFallback}
            onChange={(assignedToFallback) => {
              let _assignedToFallback = isEmpty(assignedToFallback)
                ? undefined
                : assignedToFallback;
              if (_assignedToFallback) {
                _assignedToFallback = {
                  ..._assignedToFallback,
                  fieldMapping: {
                    ..._assignedToFallback?.fieldMapping,
                    ...assignedTo?.fieldMapping,
                  },
                };
              }
              onChange({
                assignedTo,
                assignedToFallback: _assignedToFallback,
              });
            }}
            objectType={objectType}
            isFallback
          />
          {assignedToFallback && (
            <Box>
              <IconButton
                disabled={false}
                onClick={() => {
                  onChange({
                    assignedTo,
                    assignedToFallback: undefined,
                  });
                }}
                variant="flat"
                size="small"
              >
                <Delete />
              </IconButton>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};
